import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import Dialog from "sap/m/Dialog";
import JSONModel from "sap/ui/model/json/JSONModel";


export default class MessageDialogController extends BaseTypeController {
    private dialog: Dialog;
    private _oDialogModel: JSONModel;


    onInit(): void {
        super.onInit();
        this.dialog = this.getView().byId("messageDialog") as Dialog;
    }

    public openDialog(dialogTitle: string, dialogContent: string): void {
        this._oDialogModel = new JSONModel({
            dialogTitle: dialogTitle,
            dialogContent:  "<div style='margin: 10px'>" + dialogContent + "</div>",
        });
        this.getView().setModel(this._oDialogModel, "dialog");
        this.dialog.open();
    }

    public onCloseDialog() {
        this.dialog.close();
    }

}